import classNames from "classnames";
import styles from "./index.module.less";
import { useMemo, useState } from "react";
import { Button, Checkbox, Empty, Flex, Input, Pagination, Radio } from "antd";
import SearchIcon from "./imgs/search.svg?react";
import JobCard from "./components/JobCard";
import { useSetState } from "ahooks";
import EmptyIcon from "@/assets/imgs/empty.svg?react";
import JobDetail from "./components/JobDetail";
import { JobDto, tabs } from "./constant";
import ArrowLeftIcon from "@/assets/imgs/return.png";
import SVGIcon from "@/components/SVGIcon";
import UploadResumeModel from "@/components/UploadResumeModel";
import EmailModal from "@/components/EmailModal";
import P1Content from "@/components/P1Content";
import { isMobile } from "@/utils";
import MobileJoinUs from "./mobile";
const PAGE_SIZE = 10;
const JoinUs = () => {
  const [activeTab, setActiveTab] = useState("social");
  const [query, setQuery] = useState("");
  const jobs = useMemo(() => {
    return tabs.find((tab) => tab.value === activeTab)?.jobs || [];
  }, [activeTab]);
  const [pageState, setPageState] = useSetState({
    search: "",
    categories: [] as string[],
    locations: [] as string[],
    page: 1,
    pageSize: PAGE_SIZE,
  });
  const categories = jobs
    .map((job) => job.category)
    .filter((v, i, a) => a.indexOf(v) === i);
  const locations = jobs
    .map((job) => job.locations)
    .flat()
    .filter((v, i, a) => a.indexOf(v) === i);
  const list = useMemo(() => {
    return jobs.filter((job) => {
      const matchCategory = pageState.categories.length
        ? pageState.categories.includes(job.category)
        : true;
      const matchLocation = pageState.locations.length
        ? job.locations.some((location) =>
            pageState.locations.includes(location)
          )
        : true;
      const matchSearch = job.title.includes(pageState.search);
      return matchCategory && matchLocation && matchSearch;
    });
  }, [pageState, jobs]);
  const slicedList = useMemo(() => {
    return list.slice(
      (pageState.page - 1) * pageState.pageSize,
      pageState.page * pageState.pageSize
    );
  }, [list, pageState]);
  const [detail, setDetail] = useState<any>(null);

  const [visible, setVisible] = useState(false);
  return (
    <div className={styles.joinUs}>
      <div className={styles.p1}>
        <P1Content
          title="加入我们"
          subtitle="与我们一起，塑造下一代数字员工"
          showBtn={false}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.tabs}>
          {tabs.map((tab) => (
            <div
              key={tab.value}
              className={classNames(styles.tab, {
                [styles.active]: tab.value === activeTab,
              })}
              onClick={() => {
                setActiveTab(tab.value);
                setPageState({
                  search: "",
                  categories: [],
                  locations: [],
                  page: 1,
                  pageSize: PAGE_SIZE,
                });
                setQuery("");
                setDetail(null);
              }}
            >
              {tab.label}
            </div>
          ))}
        </div>
        <div className={styles.p2_inner}>
          <Flex
            align="center"
            justify="space-between"
            className={styles.p2_toolbar}
          >
            {detail ? (
              <Flex
                gap={12}
                align="center"
                onClick={() => {
                  setDetail(null);
                }}
                style={{
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: ".24rem",
                }}
              >
                <img
                  src={ArrowLeftIcon}
                  style={{
                    width: ".24rem",
                  }}
                />
                返回查看全部职位
              </Flex>
            ) : (
              <div className={styles.p2_title}>
                在招职位
                <span style={{ color: "#AAABB2" }}>({list.length})</span>
              </div>
            )}
            <Flex>
              <Input
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                  if (!e.target.value) {
                    setPageState({ page: 1, search: "" });
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setPageState({ page: 1, search: query });
                    setDetail(null);
                  }
                }}
                placeholder="请输入职位关键词"
                prefix={<SearchIcon />}
                className={styles.p2_input}
              />
              <div className={styles.search_btn}>搜索岗位</div>
            </Flex>
          </Flex>
          {detail ? (
            <>
              <JobDetail data={detail} onSubmit={() => setVisible(true)} />
            </>
          ) : (
            <Flex gap={".2rem"}>
              <div className={styles.menus}>
                <div className={styles.checkboxes}>
                  <div className={styles.checkboxTitle}>职位类别</div>
                  <Checkbox.Group
                    value={pageState.categories}
                    onChange={(values) =>
                      setPageState({ categories: values as string[], page: 1 })
                    }
                    options={categories.map((category) => ({
                      label: category,
                      value: category,
                    }))}
                  />
                </div>
                <div className={styles.checkboxes}>
                  <div className={styles.checkboxTitle}>工作地点</div>
                  <Checkbox.Group
                    value={pageState.locations}
                    onChange={(values) =>
                      setPageState({ locations: values as string[], page: 1 })
                    }
                    options={locations.map((location) => ({
                      label: location,
                      value: location,
                    }))}
                  />
                </div>
              </div>
              <div
                className={classNames(styles.positions, {
                  [styles.noData]: list.length === 0,
                })}
              >
                {list.length === 0 && (
                  <Empty
                    className={styles.noData}
                    image={<EmptyIcon />}
                    description="暂无数据"
                  />
                )}
                {slicedList.map((job, index) => (
                  <JobCard
                    key={index}
                    data={job}
                    onClick={() => {
                      setDetail(job);
                    }}
                  />
                ))}
                {list.length > 0 && (
                  <Pagination
                    className={styles.pagination}
                    total={list.length}
                    current={pageState.page}
                    pageSize={pageState.pageSize}
                    onChange={(page, pageSize) =>
                      setPageState({ page, pageSize })
                    }
                  />
                )}
              </div>
            </Flex>
          )}
        </div>
      </div>
      <EmailModal visible={visible} onClose={() => setVisible(false)} />
    </div>
  );
};
export default isMobile() ? MobileJoinUs : JoinUs;
